var map = {
	"./terms_el-GR.md": [
		7323,
		323
	],
	"./terms_en-GB.md": [
		5585,
		585
	],
	"./terms_fr-BE.md": [
		8012,
		12
	],
	"./terms_ja-JP.md": [
		2264,
		264
	],
	"./terms_nl-BE.md": [
		4302,
		302
	],
	"./terms_pt-BR.md": [
		2077,
		77
	],
	"./terms_pt-PT.md": [
		9261,
		261
	],
	"./terms_zh-TW.md": [
		9846,
		846
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9222;
module.exports = webpackAsyncContext;